export const messages = {
  error: {
    id: "download-item.error",
    defaultMessage: "An error occurred while downloading the file",
  },
};
